import { cn } from "../../../../lib/utils";
import { Alert, AlertBody, AlertTitleRow } from "../../../ui/alert";
import { FB_STORY_PROMO_ADD_PAGE_URL } from "./fb-story-promo";
import { NewPillMark } from "./NewPillMark";

export interface FbStoryPromoCalloutProps {
  pageLabels: string[];
  canAddAccounts: boolean;
  onAddPage: () => void;
  onDismiss: () => void;
  className?: string;
}

const LEAD =
  "Stories now publish to Facebook pages as well as Instagram, from the same post.";

function bodyCopy(pageLabels: string[], canAddAccounts: boolean) {
  if (pageLabels.length === 1) {
    return `${LEAD} Select ${pageLabels[0]} in Accounts above to include it.`;
  }
  if (pageLabels.length > 1) {
    return `${LEAD} Select your Facebook pages in Accounts above to include them.`;
  }
  return canAddAccounts
    ? `${LEAD} Add a Facebook page to use it.`
    : `${LEAD} Ask your account admin to add a Facebook page.`;
}

export function FbStoryPromoCallout({
  pageLabels,
  canAddAccounts,
  onAddPage,
  onDismiss,
  className,
}: FbStoryPromoCalloutProps) {
  const showAddPage = pageLabels.length === 0 && canAddAccounts;

  return (
    <Alert variant="info" role="note" className={cn("font-inter", className)}>
      <AlertTitleRow variant="info">
        <span className="inline-flex flex-wrap items-center gap-2">
          Post this story to Facebook too
          <NewPillMark />
        </span>
      </AlertTitleRow>
      <AlertBody className="pl-7">
        <p className="m-0 text-xs leading-5 text-neutral-700">
          {bodyCopy(pageLabels, canAddAccounts)}
        </p>
        <div className="flex flex-wrap items-center gap-4">
          {showAddPage ? (
            <a
              href={FB_STORY_PROMO_ADD_PAGE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onAddPage}
              className="inline-flex w-fit items-center gap-1 font-inter text-xs font-medium text-blue-500 no-underline hover:underline"
            >
              Add a Facebook page{" "}
              <span className="sr-only">(opens in a new tab)</span>
              <i
                className="fa-regular fa-arrow-up-right-from-square text-[10px]"
                aria-hidden="true"
              />
            </a>
          ) : null}
          <button
            type="button"
            onClick={onDismiss}
            className="m-0 inline-flex items-center rounded border-0 bg-transparent p-0 text-xs font-medium text-neutral-600 hover:text-neutral-800 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          >
            Not now
          </button>
        </div>
      </AlertBody>
    </Alert>
  );
}
